/**
 * Fade carousel (eg partners)
 */

(function () {
    'use strict';

    const swiperSlide = new Swiper('.swiper-effectFade', {
        allowTouchMove: false,
        autoplay: {
            delay: 3000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 2500,
    });
})();